import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { number } from 'prop-types';
import classNames from 'classnames';
import style from './SearchNoResults.scss';
import messages from '../../locale/messages';

const localMessages = defineMessages({
  searchNoResultsLinkText: {
    id: 'searchNoResults.LinkText',
    defaultMessage: 'Reset and try again.',
    description: 'Link text to reset the filters',
  },
  searchNoResultsSecondParagraph: {
    id: 'searchNoResults.SecondParagraph',
    defaultMessage: `If you still don't find what you're looking for, some schools and programs may not be available in this application process.`,
    description: 'Text that comes after link for the no results found after a search',
  },
});

const SearchNoResults = ({ seconds=-1 }) =>
  seconds >= 0 ? (
    <div className={style.root}>
      <h3>Running calculations...</h3>
      <p className={classNames(style.p, style.pLast)}>
        <b>Please wait {seconds} seconds.</b>
      </p>
    </div>
  ) : (
    <div className={style.root}>
      <h3>
        <FormattedMessage {...messages.generalStringNoResultsFound} />
      </h3>
      <p className={style.p}>
        <a className={style.resetLink} href={encodeURI(window.location.origin + window.location.pathname)}>
          <FormattedMessage {...localMessages.searchNoResultsLinkText} />
        </a>
      </p>
      <p className={classNames(style.p, style.pLast)}>
        <FormattedMessage {...localMessages.searchNoResultsSecondParagraph} />
      </p>
    </div>
  );

SearchNoResults.propTypes = {
  seconds: number,
};

export default injectIntl(withStyles(style)(SearchNoResults));
